// IANA identifiers use underscores in place of spaces (e.g. "America/Los_Angeles")
// — display-only, never transform the value used for actual timezone lookups.
export function formatTimezoneLabel(timezone) {
    if (typeof timezone !== 'string') return '';
    return timezone.replace(/_/g, ' ');
}
